// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suivi-commande-title {
  position: relative;
  background-color: black;
  /* background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../../assets/image-lot/106-COORDONATEUR-SECURITE-PROTECTION-SANTE.jpg"); */
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 2rem 4rem;
  color: #fffdfc;
  margin-bottom: 2rem;
}

.suivi-commande-title h1,
.suivi-commande-title h2,
.suivi-commande-title .subtitle {
  color: white;
}

.suivi-commande-title h1 {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.subtitle {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 1.6rem;
  font-weight: 500;
  margin-bottom: 2rem;
}

.status-header span {
  font-size: 1.6rem;
  font-weight: 700;
  /* color: black; */
}

/* Classes de statuts */
.status-accepté {
  color: #00a708;
}

.status-brouillon {
  color: #6b7280;
}

.status-action-requise,
.status-analyser,
.status-signer,
.status-candidater,
.status-a-valider {
  color: #f4751b;
}

.status-refuser,
.status-refusé {
  color: #d90e0e;
}

.status-expirer,
.status-expiré,
.status-expire {
  color: #d90e0e;
}

.status-en-attente {
  color: #6b7280;
}

.status-text {
  color: black;
}
`, "",{"version":3,"sources":["webpack://./src/composants/SuiviHeader/SuiviHeader.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB;mFACiF;EACjF,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd","sourcesContent":[".suivi-commande-title {\n  position: relative;\n  background-color: black;\n  /* background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),\n    url(\"../../assets/image-lot/106-COORDONATEUR-SECURITE-PROTECTION-SANTE.jpg\"); */\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  padding: 2rem 4rem;\n  color: #fffdfc;\n  margin-bottom: 2rem;\n}\n\n.suivi-commande-title h1,\n.suivi-commande-title h2,\n.suivi-commande-title .subtitle {\n  color: white;\n}\n\n.suivi-commande-title h1 {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  display: block;\n}\n\n.subtitle {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  font-size: 1.6rem;\n  font-weight: 500;\n  margin-bottom: 2rem;\n}\n\n.status-header span {\n  font-size: 1.6rem;\n  font-weight: 700;\n  /* color: black; */\n}\n\n/* Classes de statuts */\n.status-accepté {\n  color: #00a708;\n}\n\n.status-brouillon {\n  color: #6b7280;\n}\n\n.status-action-requise,\n.status-analyser,\n.status-signer,\n.status-candidater,\n.status-a-valider {\n  color: #f4751b;\n}\n\n.status-refuser,\n.status-refusé {\n  color: #d90e0e;\n}\n\n.status-expirer,\n.status-expiré,\n.status-expire {\n  color: #d90e0e;\n}\n\n.status-en-attente {\n  color: #6b7280;\n}\n\n.status-text {\n  color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
